import React, { useState } from 'react';
import { Grid, Typography, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Sheet from '../../components/Sheet';
import ActionBar from '../../components/ActionBar';

export const REASON_KEYS = [
    'reasonAtJeweler',
    'reasonStoredNotSellable',
    'reasonGivenAway',
    'reasonCustomerMemo',
    'reasonMelted',
    'reasonSoldOffBook',
    'reasonUnknown',
    'reasonOther',
];

export default function ExplainSheet({ open, onClose, onConfirm }) {
    const { t } = useTranslation();
    const [freeText, setFreeText] = useState(null);

    const close = () => { setFreeText(null); onClose?.(); };

    const saveFreeText = () => {
        const trimmed = (freeText ?? '').trim();
        if (!trimmed) return;
        setFreeText(null);
        onConfirm?.(trimmed);
    };

    return (
        <Sheet
            open={open}
            onClose={close}
            actions={freeText !== null
                ? <ActionBar
                    cancel={{ label: t('common.cancel'), onClick: close }}
                    confirm={{ label: t('common.save'), onClick: saveFreeText }}
                />
                : <ActionBar cancel={{ label: t('common.cancel'), onClick: close }} />}
        >
            <Typography variant='h6' textAlign='center'>{t('inventoryCheck.review.explainHeading')}</Typography>
            <Typography textAlign='center' color='text.secondary' sx={{ marginBottom: '1rem' }}>
                {t('inventoryCheck.review.explainNote')}
            </Typography>

            {freeText !== null
                ? <TextField
                    fullWidth
                    autoFocus
                    value={freeText}
                    onChange={event => setFreeText(event.target.value)}
                    placeholder={t('inventoryCheck.review.reasonOtherPlaceholder')}
                />
                : <Grid container direction='column' sx={{ gap: '.5rem' }}>
                    {REASON_KEYS.map(key => (
                        <Button
                            key={key}
                            variant='outlined'
                            onClick={() => (key === 'reasonOther'
                                ? setFreeText('')
                                : onConfirm?.(t(`inventoryCheck.review.${key}`)))}
                        >
                            {t(`inventoryCheck.review.${key}`)}
                        </Button>
                    ))}
                </Grid>}
        </Sheet>
    );
}
